import { camelCaseToTitleCase } from "@/utils/camelCaseToTitleCase.ts";

const labelTypeMap: Record<string, string> = {
  contract: "Contract",
  oemTermsAndConditions: "OEM Terms and Conditions",
  tpoAcknowledgement:
    "TPO Acknowledgement of Program Participation Eligibility",
  serialNumberOemId: "Serial number/OEM ID",
  ptoLetter: "PTO Letter",
  changeOrder: "Change Order",
  extension: "Extension",
  other: "Other",
  systemSizingTool: "System Sizing Tool",
  performanceReport: "Performance report",
  participantEnrollmentForm: "Participant Enrollment Form",
  sdgeDataAuthorization: "SDG&E Data Authorization",
  project_signature: "Participant enrollment",
};

export const getFileTypeLabel = (type: string) => {
  if (labelTypeMap[type]) {
    return labelTypeMap[type];
  }

  return camelCaseToTitleCase(type);
};
